export function isDeveloperHost(hostname = typeof window !== 'undefined' ? window.location.hostname : '') {
  return hostname === 'developer.dejavunomad.com'
    || hostname === 'developer.localhost'
    || hostname.startsWith('developer.');
}

/** Main Déjà Vu Nomad site — not the Developer subdomain. */
export function mainAppOrigin() {
  if (process.env.REACT_APP_MAIN_APP_URL) {
    return process.env.REACT_APP_MAIN_APP_URL.replace(/\/$/, '');
  }
  if (typeof window === 'undefined') {
    return 'https://dejavunomad.com';
  }
  const { protocol, hostname, port } = window.location;
  if (!isDeveloperHost(hostname) && !hostname.startsWith('memories.')) {
    return window.location.origin;
  }
  if (hostname === 'developer.localhost' || hostname.endsWith('.localhost')) {
    const portPart = port ? `:${port}` : '';
    return `${protocol}//localhost${portPart}`;
  }
  if (hostname.startsWith('developer.')) {
    return `${protocol}//${hostname.replace(/^developer\./, '')}${port ? `:${port}` : ''}`;
  }
  return 'https://dejavunomad.com';
}

export function developerPath(subpath = '') {
  const clean = `/${String(subpath).replace(/^\//, '')}`.replace(/\/$/, '') || '/';
  if (typeof window !== 'undefined' && isDeveloperHost()) {
    return clean === '/' ? '/' : clean;
  }
  return clean === '/' ? '/developer' : `/developer${clean}`;
}

export function developerPublicBase() {
  if (process.env.REACT_APP_DEVELOPER_PUBLIC_URL) {
    return process.env.REACT_APP_DEVELOPER_PUBLIC_URL.replace(/\/$/, '');
  }
  if (typeof window !== 'undefined' && isDeveloperHost()) {
    return window.location.origin;
  }
  if (typeof window !== 'undefined') {
    return `${window.location.origin}/developer`;
  }
  return 'https://developer.dejavunomad.com';
}

/**
 * Public REST API root (no trailing /api or /v1).
 * Prefer REACT_APP_PUBLIC_API_URL; otherwise production defaults to api.dejavunomad.com
 * and local uses REACT_APP_API_URL without /api, or http://localhost:5002.
 */
export function publicApiBase() {
  if (process.env.REACT_APP_PUBLIC_API_URL) {
    return process.env.REACT_APP_PUBLIC_API_URL.replace(/\/$/, '');
  }
  if (process.env.NODE_ENV === 'production') {
    return 'https://api.dejavunomad.com';
  }
  const apiUrl = process.env.REACT_APP_API_URL;
  if (apiUrl) {
    return apiUrl.replace(/\/$/, '').replace(/\/api$/, '');
  }
  return 'http://localhost:5002';
}
